import React from 'react';
import { useDispatch } from 'react-redux';
import { SecurityPassword } from './SecurityPassword.js';
import { actions } from './SecurityPassword.actions';

const SecurityPasswordComponent = () => {
    const dispatch = useDispatch();

    const changePassword = (state, onSuccess, onError) => {
        dispatch(actions.changePassword(state, onSuccess, onError));
    };

    return <SecurityPassword changePassword={changePassword} />;
};

export default SecurityPasswordComponent;